import { render } from "./TransferBox.vue?vue&type=template&id=ae93808a"
import script from "./TransferBox.vue?vue&type=script&lang=js"
export * from "./TransferBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__